export default __webpack_public_path__ + "static/trophy-18b7d74a2f0db7a9bc0476a5faf834a2.jpeg";